import * as _secp256k2 from "@noble/curves/secp256k1";
var _secp256k = _secp256k2;
try {
  if ("default" in _secp256k2) _secp256k = _secp256k2.default;
} catch (e) {}
import { dew as _fromHexDew } from "../encoding/fromHex.js";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.compactSignatureToHex = void 0;
  const secp256k1_1 = _secp256k;
  const fromHex_js_1 = _fromHexDew();
  function compactSignatureToHex({
    r,
    yParityAndS
  }) {
    return `0x${new secp256k1_1.secp256k1.Signature((0, fromHex_js_1.hexToBigInt)(r), (0, fromHex_js_1.hexToBigInt)(yParityAndS)).toCompactHex()}`;
  }
  exports.compactSignatureToHex = compactSignatureToHex;
  //# sourceMappingURL=compactSignatureToHex.js.map
  return exports;
}